import { typeAliasMap } from './typeAliasMap';

const normalizeTypeKey = (type) => {
  if (!type || typeof type !== 'string') return '';
  const lower = type.toLowerCase().trim();
  if (!lower) return '';
  const stripped = lower.replace(/\([^)]*\)/g, ' ').replace(/unsigned/g, ' ');
  const cleaned = stripped.replace(/[^a-z0-9_]+/g, ' ').trim();
  const primary = cleaned.split(' ').filter(Boolean)[0];
  return primary || lower;
};

export const getAllTypeAliases = (type) => {
  if (!type) return [];
  const key = normalizeTypeKey(type);
  if (!key) return [];
  if (Array.isArray(typeAliasMap[key])) {
    return typeAliasMap[key];
  }
  return [key];
};


export const formatEntityName = (entity) => {
  if (!entity) return 'Unknown Entity';

  const spaced = entity.replace(/([a-z])([A-Z])/g, '$1 $2');

  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const capitalize = (str) =>
  str
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word?.slice(1))
    .join(' ');
